import env from './lib/environment';

export default env;
